import { RuleObject } from 'antd/lib/form';
import React from 'react';

import { cisloDecimalOnly30RegExp } from 'enums/regExp';

export const numberDecimalValidation = (errorSetter: React.Dispatch<React.SetStateAction<boolean>>) => [
    () => ({
        validator(_: RuleObject, value: string) {
            if (!value || cisloDecimalOnly30RegExp.test(value)) return errorSetter(false);
            // eslint-disable-next-line no-sequences
            return errorSetter(true);
        }
    })
];

export default numberDecimalValidation;
